import React, { useCallback, useEffect, useRef } from 'react'
import { useSpring } from 'react-spring'

const ScrollTo = React.memo(({ shouldScroll, onStop, scrollTo }) => {
  const shouldAnimateScroll = useRef(false)
  const [, setY] = useSpring(() => ({ y: 0 }), [])

  const getScrollTop = useCallback(
    () => document.body.scrollTop || document.documentElement.scrollTop,
    []
  )

  const onWheel = useCallback(() => {
    shouldAnimateScroll.current = false
  }, [])

  const handleScrollToTop = useCallback(() => {
    const scrollTop = getScrollTop()
    setY({
      y: scrollTo,
      reset: true,
      from: {
        y: scrollTop
      },
      onStart: () => {
        shouldAnimateScroll.current = true
        window.addEventListener('wheel', onWheel)
      },
      onRest: prop => {
        shouldAnimateScroll.current = false
        window.removeEventListener('wheel', onWheel)
        onStop()
      },
      onChange: ({ y }) => {
        if (shouldAnimateScroll.current) {
          if (y) {
            document.body.scrollTop = document.documentElement.scrollTop = y
          }
        }
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (shouldScroll) {
      if (getScrollTop() !== 0) {
        handleScrollToTop()
      } else {
        onStop()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldScroll])

  return null
})

export default ScrollTo
